<template>
  <div>
    <el-menu :class="menuMode === 'vertical' ? 'vertical-menu_container' : 'horizontal-menu_container'"  :default-active="activeMenu" :mode="menuMode" @select="selectMenu">
      <el-menu-item index="messages">消息列表</el-menu-item>
      <el-menu-item index="articles">况客研究</el-menu-item>
      <el-menu-item index="focuses">轮播图</el-menu-item>
      <el-menu-item index="categories">文章分类</el-menu-item>
    </el-menu>
    <div class="data_container">
      <div class="data-header_container">
        <el-button size="mini" type="primary" icon="el-icon-circle-plus-outline" @click="createArticle">新建</el-button>
        <el-link class="right-direction" type="info" @click="quitSite"><i class="el-icon-s-custom"></i>退出</el-link>
      </div>
      <div>
        <a v-for="(item,key) in articles" :key="key" :href="item.url" target="_blank" class="article_container">
          <p>
            <span class="article-title_container">{{item.title}}</span>
            <span v-if="item.isAuthorization" class="article-auth_container">需要授权</span>
            <img v-if="item.image" class="article-image_container" :src="item.image" :alt="item.title">
          </p>
          <p>
            <span class="article-category_container">{{item.category}}</span>
          </p>
          <p class="article-content_container">{{item.content}}</p>
          <p>
            <span v-if="item.tags && item.tags.length" class="article-info_container">{{item.tags.join(', ')}}</span>
            <span class="article-info_container">{{item.date}}</span>
            <el-button v-if="item.isOpen" icon="el-icon-view" type="text" size="small" class="open-status" @click.native.prevent="toggleRow(item)">隐藏</el-button>
            <el-button v-else icon="el-icon-view" type="text" size="small" class="close-status" @click.native.prevent="toggleRow(item)">显示</el-button>
            <el-button icon="el-icon-edit" @click.native.prevent="editRow(item)" type="text" size="small">编辑</el-button>
            <el-button
              icon="el-icon-delete"
              type="text"
              size="small"
              class="delete-status"
              @click.native.prevent="deleteRow(key, articles)">
              移除
            </el-button>
          </p>
        </a>
      </div>
      <el-dialog title="编辑文章" :visible.sync="editDialogStatus">
        <EditArticle :articleData="editDialogData" :submitData="submitData"></EditArticle>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import EditArticle from '../components/EditArticle'
import * as moment from 'moment'

export default {
  name: 'articles',
  components: {
    EditArticle
  },
  data () {
    return {
      activeMenu: 'articles',
      menuMode: 'vertical',
      articles: [],
      editDialogStatus: false,
      placeholder: require('@/assets/logo.png'),
      editDialogData: {
        title: '',
        category: '',
        tags: [],
        content: '',
        isOpen: false,
        image: '',
        url: ''
      }
    }
  },
  async created () {
    const screenWidth = document.body.clientWidth
    if (screenWidth < 500) {
      this.menuMode = 'horizontal'
    } else {
      this.menuMode = 'vertical'
    }
    const resp = await this.$http.get('/articles/?type=article&isOpen=all')
    if (resp.articles) {
      this.articles = resp.articles
      this.articles = this.articles.map(x => {
        x.date = moment(x.publishedTime || x.createdTime).format('YYYY-MM-DD')
        return x
      })
    } else {
      this.$message({
        message: resp.error,
        type: 'warning'
      })
    }
  },
  methods: {
    selectMenu (key, keyPath) {
      if (key !== 'articles') {
        if (key === 'messages') {
          this.$router.push('/')
        } else {
          this.$router.push(`/${key}/`)
        }
      }
    },
    quitSite () {
      sessionStorage.clear()
      this.$router.push('/signin/')
    },
    createArticle () {
      this.editDialogData = {
        title: '',
        category: '',
        tags: [],
        content: '',
        isOpen: false,
        image: '',
        url: ''
      }
      this.editDialogStatus = true
    },
    async submitData () {
      const resp = await this.postArticle()
      resp.article.date = moment(resp.article.publishedTime || resp.article.createdTime).format('YYYY-MM-DD')
      let isCreated = true
      this.articles = this.articles.map(x => {
        if (x._id === resp.article._id) {
          x = resp.article
          isCreated = false
        }
        return x
      })
      if (isCreated) {
        this.articles.unshift(resp.article)
      }
      this.editDialogData = {
        title: '',
        category: '',
        tags: [],
        content: '',
        isOpen: false,
        image: '',
        url: ''
      }
      this.editDialogStatus = false
      return resp
    },
    async postArticle () {
      const { editDialogData } = this
      let resp = null
      if (!editDialogData.publishedTime) {
        editDialogData.publishedTime = moment().format('YYYY-MM-DD')
      }
      if (editDialogData._id) {
        resp = await this.$http.put(`/articles/${editDialogData._id}/`, editDialogData)
      } else {
        resp = await this.$http.post('/articles/', editDialogData)
      }
      return resp
    },
    async toggleRow (row) {
      row.isOpen = !row.isOpen
      const resp = await this.$http.put(`/articles/${row._id}`, {
        isOpen: row.isOpen
      })
      if (resp.article) {
      } else {
        this.$message({
          message: resp.error,
          type: 'warning'
        })
      }
    },
    async editRow (row) {
      this.editDialogData = row
      this.editDialogStatus = true
    },
    async deleteRow (index, rows) {
      const articleId = rows[index]._id
      const resp = await this.$http.delete(`/articles/${articleId}/`)
      if (resp.article) {
        rows.splice(index, 1)
        this.$message({
          message: '移除成功',
          type: 'success'
        })
      } else {
        this.$message({
          message: resp.error,
          type: 'warning'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.vertical-menu_container {
  display: inline-block;
  height: 600px;
  margin: 0 0 50px 0;
  vertical-align: top;
  width: 90px;
}

.horizontal-menu_container {
  margin: 0 0 50px 0;
}

.data_container {
  box-sizing: border-box;
  display: inline-block;
  padding: 0 0 0 20px;
  width: 78%;

  .data-header_container {
    border-bottom: 1px solid #ccc;
    margin-bottom: 30px;
    overflow: hidden;
    padding-bottom: 10px;
  }

  .right-direction {
    float: right;
  }

  .close-status {
    color: #ccc;
  }

  .delete-status {
    color: #ea4335;
  }
}

p {
  margin: 6px;
}

.article_container {
  background-color: #fefefe;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-shadow: 4px 4px #fefefe;
  color: #666;
  display: block;
  margin-bottom: 20px;
  min-height: 120px;
  padding: 10px;
  text-decoration: none;

  .article-auth_container {
    color: #34a853;
    display: inline-block;
    font-size: 12px;
    font-style: italic;
    padding: 0 0 0 10px;
  }

  .article-image_container {
    float: right;
    height: 100px;
    vertical-align: top;
  }

  .article-category_container {
    color: #f9bc04;
    display: inline-block;
    font-size: 14px;
    font-weight: 600;
    padding: 0 6px 0 0;
  }

  .article-content_container {
    color: #666;
    font-size: 14px;
  }

  .article-info_container {
    color: #aaa;
    display: inline-block;
    font-size: 14px;
    padding: 0 50px 0 0;
  }
}

// $red-color: #ea4335;
// $green-color: #34a853;
// $blue-color: #4285f4;
// $yellow-color: #f9bc04;

</style>
